import React from "react";

interface Props {
  children: React.ReactElement;
  waitBeforeShow?: number;
}

/** ディレイ */
export function Delayed({ children, waitBeforeShow = 500 }: Props) {
  const [isShown, setIsShown] = React.useState(false);

  React.useEffect(() => {
    let cleanedUp = false;

    setTimeout(() => {
      if (!cleanedUp) {
        setIsShown(true);
      }
    }, waitBeforeShow);

    return function cleanup() {
      cleanedUp = true;
    };
  }, [waitBeforeShow]);

  return isShown ? children : null;
}
